import styled from "styled-components";

export const StyledTitle = styled.div`
  margin-bottom: 7px;
`;
